/** Ausgabekanäle eines Erscheinungsbilds; muss zu den Kanalwerten im Backend passen. */
export const DOCUMENT_CHANNEL = { letter: "Letter", email: "Email", whatsApp: "WhatsApp" } as const;

/** Seitennummern des Briefbogens: erste Seite und Folgeseiten. */
export const BLOCK_SHEET = { first: 1, following: 2 } as const;

/** Rollen der Tabellenstile im Vorschaudokument. */
export const TABLE_STYLE_ROLE = { header: "headerStyle", cell: "cellStyle", total: "totalStyle" } as const;

/** Tastenwert der Entfernen-Taste (nicht in den gemeinsamen Tastenkonstanten enthalten). */
export const KEY_DELETE = "Delete";

/** Format des exportierten Erscheinungsbilds. */
export const APPEARANCE_EXPORT_VERSION = 2;
export const APPEARANCE_EXPORT_JSON_INDENT = 2;

/** Basis der Zeitstempel-Kodierung in Baustein-IDs. */
export const BLOCK_ID_TIMESTAMP_RADIX = 36;

/** Erster Zählerwert, wenn ein Bausteinschlüssel bereits vergeben ist (`typ-2`). */
export const BLOCK_KEY_FIRST_DUPLICATE_INDEX = 2;

/** Vorgabehöhen von Logo und Abstandhalter; muss zu `DocumentLayoutBlocks.Defaults` im Backend passen. */
export const LOGO_DEFAULT_HEIGHT_MM = 20;
export const LOGO_DEFAULT_HEIGHT_PX = 48;
export const SPACER_DEFAULT_HEIGHT_MM = 5;
export const SPACER_DEFAULT_HEIGHT_PX = 20;

/** Vorgaben des Fußbereichs. */
export const FOOTER_DEFAULT_COLUMN_COUNT = 3;
export const FOOTER_DEFAULT_ROW_COUNT = 3;
export const FOOTER_TWO_COLUMN_COUNT = 2;

/** Trennlinie: volle Breite und Standardstärke in Punkt. */
export const DIVIDER_FULL_WIDTH_PERCENT = 100;
export const DIVIDER_DEFAULT_BORDER_WIDTH_PT = 0.5;

/** Vorgaben für Zeilenhöhe und Absatzabstand je Ausgabe. */
export const EMAIL_DEFAULT_LINE_HEIGHT = 1.6;
export const PAGE_DEFAULT_LINE_HEIGHT = 1.35;
export const EMAIL_DEFAULT_PARAGRAPH_SPACING_PX = 14;
export const PAGE_DEFAULT_PARAGRAPH_SPACING_PT = 6;

/** Umrechnung Millimeter in Punkt. */
export const POINTS_PER_INCH = 72;
export const MM_PER_INCH = 25.4;

/** Obergrenzen der Abstandseingabe. */
export const MAX_SPACING_PX = 240;
export const MAX_SPACING_MM = 60;
export const MAX_HEAD_SPACING_ABOVE_MM = 120;

/** Spalten der Aktionsspalte in der Liste (Anzahl Symbole) und deren Breite. */
export const APPEARANCE_LIST_ACTION_SLOT_COUNT = 3;
export const APPEARANCE_LIST_ACTION_COLUMN_WIDTH = 200;
